import { useRef } from 'react';

import type { DIALOG_TRIGGER } from './constant';
import type { DIALOG_HANDLE } from './type';

const useVDialogHandle = () => {
  const dialogRef = useRef<DIALOG_HANDLE>(null);

  const setVisibleWithTrigger = <T extends string>(
    visible: boolean,
    trigger: T,
  ) => {
    dialogRef.current?.setHideTrigger(trigger as DIALOG_TRIGGER);
    visible ? dialogRef.current?.show() : dialogRef.current?.hide();
  };

  return {
    dialogRef,
    setVisibleWithTrigger,
  };
};

export default useVDialogHandle;
